/* Any off-site link inside our sections opens in a new tab.
   Backstop for links pasted into rich text fields, where Shopify strips target. */
document.querySelectorAll('.bw a[href^="http"]').forEach(function (a) {
  if (a.target) return;
  try {
    if (new URL(a.href).host === window.location.host) return;
  } catch (e) { return; }
  a.target = '_blank';
  a.rel = (a.rel ? a.rel + ' ' : '') + 'noopener';
});
